import script from "./static-article.vue?vue&type=script&lang=tsx"
export * from "./static-article.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__